import { render, staticRenderFns } from "./QA.vue?vue&type=template&id=52e07263&scoped=true&"
import script from "./QA.vue?vue&type=script&lang=js&"
export * from "./QA.vue?vue&type=script&lang=js&"
import style0 from "./QA.vue?vue&type=style&index=0&id=52e07263&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e07263",
  null
  
)

export default component.exports